import classNames from "classnames"
import Icon from "components/Stacker/components/Icon/Icon"
import isMobile from "components/Stacker/utils/device-check"
import PropTypes from "prop-types"
import React, { useRef, useEffect } from "react"
import "./InfoBox.scss"
import shadowDOM from "components/Stacker/utils/shadowDOM"
import { useI18nContext } from "i18n/i18n-react"

function InfoBox(props) {
  const ref = useRef()
  const { LL } = useI18nContext()
  const { title, description, onMoreInfoClick, onProductInfoCloseClick } = props

  useEffect(() => {
    shadowDOM.addEventListener("mousedown", handleClickOutside)
    return () => {
      shadowDOM.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  const handleClickOutside = (e) => {
    const { onProductInfoCloseClick } = props

    if (ref.current && !ref.current.contains(e.target)) {
      onProductInfoCloseClick()
    }
  }

  const classes = classNames("info-box card fadein")
  let stackerHeight = 0
  let positionTop = null
  if (ref && isMobile()) {
    const productList = shadowDOM.getElementById("product_list")
    const mainContentArea = shadowDOM.getElementById("mainContentArea")
    stackerHeight =
      window.innerHeight - productList.offsetHeight - mainContentArea.offsetTop
    const infoBoxPosition = ref ? stackerHeight / 2 - ref.clientHeight / 2 : 0
    positionTop = { top: infoBoxPosition }
  } else {
    positionTop = { top: "50%", transform: "translateY(-50%)" }
  }
  return (
    <div id="info-box" className={classes} ref={ref} style={positionTop}>
      <h5>{title}</h5>
      <p dangerouslySetInnerHTML={description} />
      {/* MORE INFO LINK - Enable After Quickview is Complete */}
      {/*<button className="btn btn-text" onClick={onMoreInfoClick}>*/}
      {/*  {LL.bracelets.moreInfo()}*/}
      {/*</button>*/}
      <button className="btn btn-close" onClick={onProductInfoCloseClick}>
        <Icon
          additionalClassNames="icon-icon-close"
          iconName="icon-icon-close"
        />
      </button>
    </div>
  )
}

InfoBox.propTypes = {
  description: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  onMoreInfoClick: PropTypes.func.isRequired,
  onProductInfoCloseClick: PropTypes.func.isRequired,
}

export default InfoBox
